
import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  loading = signal<boolean>(false);

  startLoading() {
    this.loading.set(true);
  }

  stopLoading() {
    this.loading.set(false);
  }

  simulatePageLoad(duration: number = 3000) {
    this.startLoading();
    setTimeout(() => {
      this.stopLoading();
    }, duration);
  }
}

